const fallbackPath = "/";

export function getRedirectAfterSignIn({
	redirectParam,
	origin,
}: {
	redirectParam: string | null;
	origin: string;
}): string {
	if (redirectParam === null) {
		return fallbackPath;
	}

	const redirectUrl = parseUrl({ value: redirectParam, base: origin });
	// Comparing parsed URLs (rather than string prefixes) also rejects
	// protocol-relative ("//evil.com") and backslash ("/\evil.com") inputs,
	// which the URL parser resolves to a foreign host.
	if (redirectUrl === null || !isSameOrigin({ url: redirectUrl, origin })) {
		return fallbackPath;
	}

	const redirectPath = `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
	// A same-origin URL can still have a pathname starting with "//" (for
	// example "/.//evil.com"), which becomes protocol-relative once assigned
	// to window.location.href. Resolve the path again to make sure it stays.
	const resolvedRedirectUrl = parseUrl({ value: redirectPath, base: origin });
	if (
		resolvedRedirectUrl === null ||
		!isSameOrigin({ url: resolvedRedirectUrl, origin })
	) {
		return fallbackPath;
	}

	return redirectPath;
}

// URL.origin is "null" for non-special schemes such as the iOS Capacitor
// "capacitor://localhost", so it cannot be used to compare origins there.
// Protocol and host are populated for every scheme.
function isSameOrigin({ url, origin }: { url: URL; origin: string }): boolean {
	const originUrl = new URL(origin);
	return url.protocol === originUrl.protocol && url.host === originUrl.host;
}

function parseUrl({
	value,
	base,
}: {
	value: string;
	base: string;
}): URL | null {
	try {
		return new URL(value, base);
	} catch {
		return null;
	}
}
